module.exports = __webpack_public_path__ + "static/media/airplanemode_active.037beea5.svg";